export const generateUserModel = () => ({
  name: '',
  email: '',
  password: '',
  barcode: '',
  tenant: '',
});

export const generateUserBarcodeModel = () => ({ barcode: '', description: '' });
